import { Component, OnDestroy, OnInit } from '@angular/core';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'act-dialog-multi-payment',
  templateUrl: './dialog-multi-payment.component.html',
  styleUrls: ['./dialog-multi-payment.component.scss']
})
export class DialogMultiPaymentComponent implements OnInit, OnDestroy {
  data: {
    currency: string;
    netPrice: number;
    userBudget: number;
    overPrice: number
  };

  constructor(
    private utilitiesService: UtilitiesService,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.utilitiesService.unlockBody();
    this.utilitiesService.unlockBodyBackdrop();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-multi-payment/dialog-multi-payment.component.ts